/**
Project: Voice Panel (c)
Title: Admin Number Type Reducer
Description: Reducer for the number type records
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import {
    NUMBERTYPES_ALL_RECORDS,
    NUMBERTYPES_DISPLAY_RECORDS,
    NUMBERTYPES_PAGE_RECORDS
} from "./constants";

const INIT_STATE = {
    numbertypesAllRecords: [],
    numbertypesDisplayRecords: [],
    numbertypesPageRecords: [],
};

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case NUMBERTYPES_ALL_RECORDS:
            return {
                ...state,
                numbertypesAllRecords: [...action.payload],
            };
        case NUMBERTYPES_DISPLAY_RECORDS:
            return {
                ...state,
                numbertypesDisplayRecords: [...action.payload],
            };
        case NUMBERTYPES_PAGE_RECORDS:
            return {
                ...state,
                numbertypesPageRecords: [...action.payload],
            };
        default:
            return state;
    }
}